/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 15:28:41
 * @Description: 导入所有全局样式文件
 */

import "./all.scss";
